import { CSSProperties, ReactElement } from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { Input } from 'components';
import { DamScheduleFormValues } from '../../types';
import { FORM_VALIDATORS } from '../../constants';
import { ControlledInputContainer } from './styles';

interface ControlledInputProps<Name extends keyof DamScheduleFormValues> {
  label: string;
  name: Name;
  disabled?: boolean;
  placeholder?: string;
  onChange?: (value: string) => void;
  mask?: (string | RegExp)[];
  style?: CSSProperties;
  rules?: RegisterOptions<DamScheduleFormValues, Name>;
}

export function ControlledInput<Name extends keyof DamScheduleFormValues>({
  disabled,
  label,
  name,
  placeholder,
  onChange,
  mask,
  style,
  rules,
}: Readonly<ControlledInputProps<Name>>): ReactElement {
  const { control } = useFormContext<DamScheduleFormValues>();

  return (
    <ControlledInputContainer>
      <Controller<DamScheduleFormValues, Name>
        control={control}
        name={name}
        rules={{ ...FORM_VALIDATORS[name], ...rules } as RegisterOptions<DamScheduleFormValues, Name>}
        render={({
          field: {
            onChange: onFieldChange, onBlur, value,
          }, fieldState,
        }) => (
          <Input
            label={label}
            placeholder={placeholder}
            onChange={(event) => {
              onFieldChange(event);
              if (onChange) onChange(event.target.value);
            }}
            mask={mask}
            onBlur={onBlur}
            value={value as string}
            error={fieldState.error?.message}
            disabled={disabled}
            style={{
              width: '100px',
              height: '50px',
              ...style,
            }}
            guide={false}
          />
        )}
      />
    </ControlledInputContainer>
  );
}
